import { render, staticRenderFns } from "./DetailLowMovingStock.vue?vue&type=template&id=3acc692a&scoped=true&"
import script from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
export * from "./DetailLowMovingStock.vue?vue&type=script&lang=js&"
import style0 from "./DetailLowMovingStock.vue?vue&type=style&index=0&id=3acc692a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc692a",
  null
  
)

export default component.exports